import type { TableColumn } from './column';

const DATE_FMT = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});

const TIME_FMT = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
});

function toDate(value: unknown): Date | null {
    if (value === null || value === undefined || value === '') return null;
    const date =
        value instanceof Date ? value : new Date(value as string | number);
    return Number.isNaN(date.getTime()) ? null : date;
}

function datePart(fmt: Intl.DateTimeFormat, date: Date, type: string): string {
    return fmt.formatToParts(date).find((p) => p.type === type)?.value ?? '';
}

export function formatDate(value: unknown): string {
    const date = toDate(value);
    if (!date) return '';
    return `${datePart(DATE_FMT, date, 'day')}.${datePart(DATE_FMT, date, 'month')}.${datePart(DATE_FMT, date, 'year')}`;
}

export function formatDateTime(value: unknown): string {
    const date = toDate(value);
    return date ? `${formatDate(date)} ${TIME_FMT.format(date)}` : '';
}

export const builtInColumnTypes: Record<string, Partial<TableColumn<never>>> = {
    shortDate: {
        filter: 'date',
        render: (ctx) => formatDate(ctx.value),
    },
    dateTime: {
        filter: 'date',
        render: (ctx) => formatDateTime(ctx.value),
    },
    boolean: {
        filter: 'set',
        filterOptions: [
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
        ],
        render: (ctx) =>
            ctx.value === true || ctx.value === 'true' ? 'Yes' : 'No',
    },
    number: {
        filter: 'number',
    },
    enum: {
        filter: 'set',
        render: (ctx) => {
            const key = String(ctx.value);
            return ctx.column.labels?.[key] ?? key;
        },
    },
};
